'use strict';

const jQuery = require('jquery');

const RequestHandler = require('./../../../core/requestHandler');

module.exports.findBy = function(data) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd = jQuery.Deferred();

    RequestHandler.setBaseUrl('/api');

    RequestHandler.read('group-types', data).done((groups) => {
        dfd.resolve(groups.filter((group) => {
            return group.id !== 'super_admin';
        }));
    });

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd.promise();
};

module.exports.save = function(data, uid) {
    let result;
    let currentApiUrl = RequestHandler.getBaseUrl();

    RequestHandler.setBaseUrl('/api');

    if (uid) {
        result = RequestHandler.update('group-types/' + uid, data);
    } else {
        result = RequestHandler.create('group-types', data);
    }

    RequestHandler.setBaseUrl(currentApiUrl);

    return result;
};

module.exports.delete = function(groupId) {
    let result;
    let currentApiUrl = RequestHandler.getBaseUrl();

    RequestHandler.setBaseUrl('/api');

    result = RequestHandler.del('group-types/' + groupId);

    RequestHandler.setBaseUrl(currentApiUrl);

    return result;
};

module.exports.addUser = function(groupId, userId) {
    let dfd;
    let currentApiUrl = RequestHandler.getBaseUrl();

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.create(`group-types/${groupId}/add-user/${userId}`);

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};


module.exports.removeUser = function(groupId, userId) {
    let dfd;
    let currentApiUrl = RequestHandler.getBaseUrl();

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.del(`group-types/${groupId}/remove-user/${userId}`);

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.getUsers = function(groupId) {
    let dfd;
    let currentApiUrl = RequestHandler.getBaseUrl();

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.read(`group-types/${groupId}/users`);

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

